module.exports = __webpack_public_path__ + "static/media/red-s.1f685a74.svg";